import {ECalendarType, TCalendarType} from '../Calendar';

type TDatePickerValue = Date | {startDate: Date; endDate: Date};

type THandler = (value: TDatePickerValue | null) => void;

const DEFAULT_WIDTH: Record<TCalendarType, string> = {
  [ECalendarType.DATE_RANGE]: '252px',
  [ECalendarType.DATE]: '150px',
};

const WIDE_LETTERS_COMPENSATOR = 1.5;

export {DEFAULT_WIDTH, WIDE_LETTERS_COMPENSATOR};
export type {THandler, TDatePickerValue};
